"use client";
import { useState, useEffect, useRef } from "react";
import Link from "next/link";

interface ChangeOSCompProps {
  onOSSelect: () => void;
}

const ChangeOSComp: React.FC<ChangeOSCompProps> = ({ onOSSelect }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        title="Change OS"
        aria-label="Change OS"
        onClick={toggleDropdown}
        className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
      >
        Choose OS
      </button>

      {isOpen && (
        <div className="right-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <Link
              href="/windows"
              onClick={() => {
                onOSSelect();
                setIsOpen(false);
              }}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
            >
              Windows
            </Link>
            <Link
              href="/mac"
              onClick={() => {
                onOSSelect();
                setIsOpen(false);
              }}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
            >
              MacOS
            </Link>
            <Link
              href="/android"
              onClick={() => {
                onOSSelect();
                setIsOpen(false);
              }}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
            >
              Android
            </Link>
            <Link
              href="/ios"
              onClick={() => {
                onOSSelect();
                setIsOpen(false);
              }}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
            >
              iOS
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangeOSComp;
